import previewImg from "./previewImg/"
import openMenu from "./menu/"
import copy from "./copy/"
import dialog from "./dialog/"

const install = function (Vue, opts = {}) {

    // 添加图片预览方法
    Vue.prototype.$previewImg = previewImg;

    Vue.prototype.$openMenu = openMenu;

    Vue.prototype.$copy = copy;

    Vue.component("p-dialog", dialog)

};

export default install


// WEBPACK FOOTER //
// ./src/vue/components/plugIn/index.js